// Module
var code = `<div class="ha-overlay container"> <div class="row"> <div class="col-12 text-center px-0 py-5"> <div class="progress w-100"> <div class="progress-bar bg-secondary" role="progressbar" style="width:100%" aria-valuenow="12" aria-valuemin="0" aria-valuemax="100"></div> </div> </div> <div class="quiz-container"> </div> </div> </div>`;
// Exports
export default code;